import { getBaseQuery, getBaseUrl } from '../../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

interface RunAppdimensionParams {
    AppDimensionGuid: string
    PageNumber: number
    PageSize: number
    SearchText: string
    SortDir: string
    SortField: string
}
interface GetAppDImensionRows {
    AppDimensionGuid: string
    AppDimensionRowId: any
}
interface EditDimensionRow {
    AppDimensionGuid: string
    AppDimensionRowId: any
    AppDimensionRow: any
}
interface AddNewDimensionRow {
    AppDimensionGuid: string
    AppDimensionRowId: -9999
    AppDimensionRow: any
}
const baseUrl = `${getBaseUrl()}/API/v3/AppDimension`
export const AppDimensionApi = createApi({
    reducerPath: 'AppDimensionApi',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        GetManagedimension: builder.query<any, void>({
            query: () => ({
                url: '/GetAppDimensions',
                method: 'POST',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        AppDimensioRows: builder.mutation<any, RunAppdimensionParams>({
            query: (paramsData) => {
                const params = new URLSearchParams()
                params.append('Guid', paramsData.AppDimensionGuid)
                const formData = new FormData()

                formData.append('AppDimensionGuid', paramsData.AppDimensionGuid)
                formData.append('PageNumber', paramsData.PageNumber.toString())
                formData.append('PageSize', paramsData.PageSize.toString())
                formData.append('SearchText', paramsData.SearchText)
                formData.append('SortDir', paramsData.SortDir)
                formData.append('SortField', paramsData.SortField)
                return {
                    url: '/FilterAppDimensionValues',
                    method: 'POST',
                    body: formData,
                    headers: {},
                }
            },
            transformResponse: (response: any) => {
                return response.data
            },
        }),
        ManageAppDimensionRows: builder.mutation<any, GetAppDImensionRows>({
            query: (paramsDatas) => {
                const params = new URLSearchParams()
                params.append('Guid', paramsDatas.AppDimensionGuid)
                const formData = new FormData()
                formData.append('AppDimensionGuid', paramsDatas.AppDimensionGuid.toString())
                formData.append('AppDimensionRowId', paramsDatas.AppDimensionRowId)

                return {
                    url: '/GetAppDimensionRow',
                    method: 'POST',
                    body: formData,
                    headers: {},
                }
            },
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
        EditAppDimensionRows: builder.mutation<any, EditDimensionRow>({
            query: (paramsDatas) => {
                const formData = new FormData()
                formData.append('AppDimensionGuid', paramsDatas.AppDimensionGuid.toString())
                formData.append('AppDimensionRowId', paramsDatas.AppDimensionRowId)
                formData.append('AppDimensionRow', paramsDatas.AppDimensionRow)
                return {
                    url: '/EditDimensionRow',
                    method: 'PUT',
                    body: formData,
                    headers: {},
                }
            },
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
        AddNewAppDimensionRows: builder.mutation<any, AddNewDimensionRow>({
            query: (paramsDatas) => {
                const formData = new FormData()
                formData.append('AppDimensionGuid', paramsDatas.AppDimensionGuid.toString())
                formData.append('AppDimensionRowId', paramsDatas.AppDimensionRowId.toString())
                formData.append('AppDimensionRow', paramsDatas.AppDimensionRow)

                return {
                    url: '/AddDimensionRow',
                    method: 'POST',
                    body: formData,
                    headers: {},
                }
            },
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
    }),
})

export const {
    useGetManagedimensionQuery,
    useAppDimensioRowsMutation,
    useManageAppDimensionRowsMutation,
    useEditAppDimensionRowsMutation,
    useAddNewAppDimensionRowsMutation,
} = AppDimensionApi
